import styled from "styled-components";

export const EmailSentSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
  padding: 2rem 1rem;
  background-color: ${({ theme }) => theme.colors["black-800"]};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
`;

export const IconContainer = styled.div`
  color: ${({ theme }) => theme.colors["blue-600"]};
`;

export const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors["white"]};
  margin-bottom: 2rem;
`;

export const Description = styled.p`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors["white"]};
  line-height: 1.5;
  gap: 1.5rem;
  margin-bottom: 1rem;
  text-align: left;
`;

export const DescriptionEmail = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors["white"]};
`;

export const DescriptionLine = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Marker = styled.span`
  font-size: 1.25rem;
  margin-right: 1rem;
  margin-left: 1rem;
`;

export const EmailHighlight = styled.strong`
  color: ${({ theme }) => theme.colors["blue-600"]};
  font-weight: 600;
`;

export const InstructionsText = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors["gray-700"]};
  line-height: 1.4;
  margin-bottom: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: start;
  gap: 1.5rem;

  h4 {
    color: ${({ theme }) => theme.colors["white"]};
  }
`;
